import React, {useState} from "react";
import "./ExperienceCard.scss";
import Modal from "../modal/Modal";

export default function ExperienceCard({cardInfo, isDark}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const GetDescBullets = ({descBullets, isDark}) => {
    return descBullets
      ? descBullets.map((item, i) => (
          <li
            key={i}
            className={isDark ? "subTitle dark-mode-text" : "subTitle"}
          >
            {item}
          </li>
        ))
      : null;
  };

  return (
    <>
      <div
        className={isDark ? "experience-card experience-card-dark" : "experience-card"}
        onClick={openModal}
      >
        <div className="experience-card-header">
          <img
            className="experience-card-logo"
            src={cardInfo.companylogo}
            alt={cardInfo.company}
          />
          <div className="experience-card-titles">
            <h3
              className={
                isDark
                  ? "experience-card-role dark-mode-text"
                  : "experience-card-role"
              }
            >
              {cardInfo.role}
            </h3>
            <p className="experience-card-company">{cardInfo.company}</p>
          </div>
        </div>
        <p className="experience-card-date">{cardInfo.date}</p>
        <p
          className={
            isDark
              ? "subTitle experience-card-desc dark-mode-text"
              : "subTitle experience-card-desc"
          }
        >
          {cardInfo.desc}
        </p>
        <button
          type="button"
          className="experience-card-more"
          aria-label={`View details of ${cardInfo.role} at ${cardInfo.company}`}
          onClick={event => {
            event.stopPropagation();
            openModal();
          }}
        >
          View details →
        </button>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        isDark={isDark}
        ariaLabel={`${cardInfo.role} at ${cardInfo.company}`}
      >
        <div className="experience-modal">
          <div className="experience-modal-header">
            <img
              className="experience-modal-logo"
              src={cardInfo.companylogo}
              alt={cardInfo.company}
            />
            <div>
              <h2 className="experience-modal-company">{cardInfo.company}</h2>
              <h3 className="experience-modal-role">{cardInfo.role}</h3>
              <p className="experience-modal-date">{cardInfo.date}</p>
            </div>
          </div>
          <p
            className={
              isDark
                ? "subTitle experience-modal-desc dark-mode-text"
                : "subTitle experience-modal-desc"
            }
          >
            {cardInfo.desc}
          </p>
          <ul className="experience-modal-bullets">
            <GetDescBullets
              descBullets={cardInfo.descBullets}
              isDark={isDark}
            />
          </ul>
          {cardInfo.technologies && cardInfo.technologies.length > 0 && (
            <div className="experience-modal-tags">
              {cardInfo.technologies.map((tech, i) => (
                <span
                  key={i}
                  className={
                    isDark ? "experience-tag experience-tag-dark" : "experience-tag"
                  }
                >
                  {tech}
                </span>
              ))}
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}
